"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("stremio/core");
var BottomSheet_1 = __importDefault(require("stremio/components/BottomSheet"));
var ActionButton_1 = __importDefault(require("stremio/components/MetaPreview/ActionButton"));
var Stream_1 = __importDefault(require("../../StreamsList/Stream"));
var Actions_less_1 = __importDefault(require("../Actions/Actions.less"));
var Playback_less_1 = __importDefault(require("./Playback.less"));
var Playback = function (_a) {
    var streams = _a.streams, _b = _a.mobile, mobile = _b === void 0 ? false : _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, core_1.useCore)();
    var _c = (0, react_1.useState)(false), streamsOpen = _c[0], setStreamsOpen = _c[1];
    var readyStreams = streams.flatMap(function (resource) {
        return resource.content.type === 'Ready' ?
            resource.content.content.map(function (stream) { return ({ stream: stream, addonName: resource.addon.manifest.name }); })
            :
                [];
    });
    var loading = streams.some(function (resource) { return resource.content.type === 'Loading'; });
    var soleStream = !loading && readyStreams.length === 1 ? readyStreams[0] : null;
    var watchLabel = t('LIVE_TV_WATCH_LIVE', { defaultValue: 'Watch live' });
    var optionsLabel = t('LIVE_TV_PLAYBACK_OPTIONS', { defaultValue: 'Playback options' });
    var openStreams = (0, react_1.useCallback)(function () { return setStreamsOpen(true); }, []);
    var closeStreams = (0, react_1.useCallback)(function () { return setStreamsOpen(false); }, []);
    var onStreamClick = function (stream) {
        setStreamsOpen(false);
        core.transport.analytics({ event: 'StreamClicked', args: { stream: stream } });
    };
    var streamOptions = (react_1.default.createElement("div", { className: Playback_less_1.default['stream-options'] },
        readyStreams.map(function (_a, index) {
            var stream = _a.stream, addonName = _a.addonName;
            return (react_1.default.createElement(Stream_1.default, { key: index, isEpg: true, className: Playback_less_1.default['stream-option'], addonName: addonName, name: !mobile && soleStream ? watchLabel : stream.name || addonName, description: !mobile && soleStream ? [stream.name || addonName, stream.description].filter(Boolean).join('\n') : stream.description, progress: null, deepLinks: stream.deepLinks, onClick: function () { return onStreamClick(stream); } }));
        }),
        loading ?
            react_1.default.createElement("div", { className: Playback_less_1.default['stream-loading'], role: 'status', "aria-label": t('STREAM_LOADING') },
                react_1.default.createElement(Stream_1.default.Placeholder, null),
                react_1.default.createElement(Stream_1.default.Placeholder, null))
            :
                null,
        !loading && readyStreams.length === 0 ?
            react_1.default.createElement("div", { className: Playback_less_1.default['stream-message'], role: 'status' }, t('NO_STREAM'))
            :
                null));
    if (!mobile) {
        return (react_1.default.createElement("div", { className: Playback_less_1.default['streams-panel'], "aria-label": optionsLabel },
            react_1.default.createElement("div", { className: Playback_less_1.default['title'] }, optionsLabel),
            streamOptions));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        soleStream ?
            react_1.default.createElement(Stream_1.default, { className: Actions_less_1.default['action-button'], compact: true, isEpg: true, addonName: soleStream.addonName, name: watchLabel, description: soleStream.addonName, progress: null, deepLinks: soleStream.stream.deepLinks, onClick: function () { return onStreamClick(soleStream.stream); } })
            :
                react_1.default.createElement(ActionButton_1.default, { className: Actions_less_1.default['action-button'], icon: 'play', label: watchLabel, variant: 'wide', role: 'button', "aria-haspopup": 'dialog', onClick: openStreams }),
        react_1.default.createElement(BottomSheet_1.default, { className: Playback_less_1.default['streams-sheet'], title: optionsLabel, show: streamsOpen, onCloseRequest: closeStreams, closeOnContentClick: false, closeOnOrientationChange: false }, streamOptions)));
};
exports.default = Playback;
